// import {
//   FETCH_JOBS_REQUEST, FETCH_JOBS_SUCCESS, FETCH_JOBS_FAILURE,
//   CREATE_JOB_REQUEST, CREATE_JOB_SUCCESS, CREATE_JOB_FAILURE,
//   UPDATE_JOB_REQUEST, UPDATE_JOB_SUCCESS, UPDATE_JOB_FAILURE,
//   DELETE_JOB_REQUEST, DELETE_JOB_SUCCESS, DELETE_JOB_FAILURE,
// } from "../actions/jobActions";

// const initialState = {
//   jobs: [],
//   loading: false,
//   error: null,
//   createStatus: null,
//   updateStatus: null,
//   deleteStatus: null,
// };

// const jobReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_JOBS_REQUEST:
//       return { ...state, loading: true, error: null };
//     case FETCH_JOBS_SUCCESS:
//       return { ...state, loading: false, jobs: action.payload };
//     case FETCH_JOBS_FAILURE:
//       return { ...state, loading: false, error: action.payload };
//     case CREATE_JOB_SUCCESS:
//       return { ...state, createStatus: "success" };
//     case UPDATE_JOB_SUCCESS:
//       return { ...state, updateStatus: "success" };
//     case DELETE_JOB_SUCCESS:
//       return {
//         ...state,
//         jobs: state.jobs.filter((job) => job.id !== action.payload),
//         deleteStatus: "success",
//       };
//     default:
//       return state;
//   }
// };

// export default jobReducer;

import {
  FETCH_JOBS_REQUEST,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  CREATE_JOB_REQUEST,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAILURE,
  UPDATE_JOB_REQUEST,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  DELETE_JOB_REQUEST,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAILURE,
} from "../actions/jobActions";

const initialState = {
  jobs: [],
  loading: false,
  error: null,
  createStatus: null,
  updateStatus: null,
  deleteStatus: null,
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {

    /* FETCH */

    case FETCH_JOBS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: action.payload,
      };

    case FETCH_JOBS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /* CREATE */

    case CREATE_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        createStatus: null,
      };

    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        createStatus: "success",
      };

    case CREATE_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        createStatus: "failed",
        error: action.payload,
      };

    /* UPDATE */

    case UPDATE_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        updateStatus: null,
      };

    case UPDATE_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        updateStatus: "success",
      };

    case UPDATE_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        updateStatus: "failed",
        error: action.payload,
      };

    /* DELETE */

    case DELETE_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        deleteStatus: null,
      };

    case DELETE_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: state.jobs.filter((job) => job.id !== action.payload),
        deleteStatus: "success",
      };

    case DELETE_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        deleteStatus: "failed",
        error: action.payload,
      };

    default:
      return state;
  }
};

export default jobReducer;